export const blogData = [
    {
        id: 1,
        title: 'Legal Disclaimer',
        description: 'Nothing in this Paper should be treated or read as a guarantee or promise of how the token will develop or the value of the token. This Paper outlines only our vision, current project status and our plans.',
        date: 'Nov 3, 2022',
        image: 'https://miro.medium.com/max/640/1*XMu7np_Bibm1D_hDK65OQw.png',
    },
    {
        id: 2,
        title: 'Seed Phase',
        description: 'eBuds are a new type of crypto asset(NFT) that is focused to create a decentralized platform that is driven by the community and powered by the people. Our project is in the Seed Phase, which means that we are focused on building a foundation for future growth. We keep our eBuds NFT funds safe by staking them.',
        date: 'Nov 14, 2022',
        image: '',
        url: 'https://medium.com/@ebuds/seed-phase-817b10af7170'
    },
    {
        id: 3,
        title: 'eBuds Roadmap for 2023 and beyond.',
        description: ' eBuds is a Decentralized Autonomous Community (DAC) powered by Draco Labs, that aims to become an Elrond node.',
        date: 'Jan 21, 2023',
        image: 'https://miro.medium.com/max/640/1*UEkiQZtQG_1qtUifR9cKcw.webp',
        url: 'https://ebuds.medium.com/ebuds-roadmap-for-2023-and-beyond-9f7288ce2419'
    },
    /* 
   
    
    {
        id: 4,
        title: 'CHECK INTERNET SPEED FROM THE COMMAND LINE',
        description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
        date: 'Sep 17, 2020',
        image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
        url: 'https://hackzism.blogspot.com/2020/07/check-internet-speed-from-command-line.html'
    },
    {
        id: 5,
        title: 'GET MICHAEL\'S OR TREVOR\'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE',
        description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
        date: 'Oct 1, 2020',
        image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
        url: 'https://hackzism.blogspot.com/2020/07/how-can-you-get-michaels-or-trevors.html'
    },
    */
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/